import { Box, Img, Text } from '@chakra-ui/react'
import React from 'react'

const SkillsCard = ({source,name}) => {
  return (
    <Box bg="white" h="160px" w="120px" border="2px solid #2253c8" p="10px">
     <Box h="80%">   
    <Img  m="auto"   h="100%" src={source} />
    </Box>
    <Text fontWeight={500} color={"#2253c8"} >{name}</Text>

    </Box>
  )
}

export default SkillsCard